// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"cd096a3d","466":"400dcb50","738":"2458a935","856":"db78202b"}[chunkId] + ".chunk.js";
};